import createStyles from '@material-ui/core/styles/createStyles'
import { Theme } from '@material-ui/core'

export default (_: Theme) =>
  createStyles({
    column1: {
      width: 160
    }
  })
